import * as S from "./styles.ts";
import { DropZone } from "@measured/puck";

interface IFlexBoxProps {
  gap?: number;
  justifyContent?: string;
  alignItems?: string;
  width?: string;
  autoMaxWidth?: boolean;
  columns?: {
    span: number;
  }[];
  padding?: {
    vertical: number;
    horizontal: number;
  };
  reverse?: boolean;
}

const GridContainer = ({
  gap,
  justifyContent,
  alignItems,
  width,
  autoMaxWidth,
  columns,
  padding,
  reverse,
}: IFlexBoxProps) => {
  return (
    <S.GridContainer
      $gap={gap}
      $justifyContent={justifyContent}
      $autoMaxWidth={autoMaxWidth}
      $alignItems={alignItems}
      $width={width}
      $padding={padding}
      $reverse={reverse}
    >
      {columns.map((c, i) => (
        <S.Col
          key={i}
          $span={c.span}
        >
          <DropZone zone={`Column ${i + 1}`} />
        </S.Col>
      ))}
    </S.GridContainer>
  );
};

export default GridContainer;
